import { isPending } from "App/apiMiddleware";
import workSpacesActionTypes from "Areas/WorkSpaces/redux/actionTypes";
import { REDUX_ROUTING_PAGE_NAMESPACE } from "Common/routingUtils";
import get from "lodash/get";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getWorkSpaceId = createSelector((state) => get(state, `[${REDUX_ROUTING_PAGE_NAMESPACE}].payload.id`), (id) => (id && Number.isFinite(Number(id)) ? Number(id) : undefined));
export const getData = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].data[${getWorkSpaceId(state)}]`), (data) => data
    ? {
        ...data,
        Projects: map(orderBy(data.Projects, ["Created"], ["desc"]), p => ({
            ...p,
            Documents: orderBy(p.Documents, ["Created"], ["desc"])
        }))
    }
    : undefined);
export const getTab = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].tab`, 0), (tab) => tab);
export const getInProgress = (state) => isPending(state, `${actionTypes.GET_WORK_SPACE}_${getWorkSpaceId(state)}`) ||
    isPending(state, `${workSpacesActionTypes.DELETE_WORK_SPACE}_${getWorkSpaceId(state)}`);
